import { render, staticRenderFns } from "./level-import.vue?vue&type=template&id=6bf1321e&scoped=true"
import script from "./level-import.vue?vue&type=script&lang=js"
export * from "./level-import.vue?vue&type=script&lang=js"
import style0 from "./level-import.vue?vue&type=style&index=0&id=6bf1321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf1321e",
  null
  
)

export default component.exports